// Emoji constants to prevent encoding issues
// Always import from this file instead of using emojis directly in code

export const EMOJIS = {
  // Food storage categories
  FRIDGE: '🥬',
  FREEZER: '🧊',
  PANTRY: '📦',
  
  // Brand and UI
  PLANT: '🌱',
  CHECKMARK: '✅',
  CHECK_MARK: '✅',  // Alias for CHECKMARK
  WARNING: '⚠️',
  TRASH: '🗑️',
  X_MARK: '❌',
  
  // Additional food-related emojis
  FOOD: '🍽️',
  SHOPPING: '🛒',
  ALERT: '⚡',
  
  // Analytics emojis
  LIGHTBULB: '💡',
  WATER_DROP: '💧',
  CHECK: '✓',
  GLOBE: '🌍',
  PARTY: '🎉',
  
  // Special characters
  BULLET: '•',
  
  // Upgrade/Premium emojis
  PEOPLE: '👥',
  CAMERA: '📸',
  CHART: '📊',
  SPARKLES: '✨',
} as const;

// Type for emoji keys
export type EmojiKey = keyof typeof EMOJIS;

// Helper function to get category emoji
export function getCategoryEmoji(category: string): string {
  const emojiMap: Record<string, string> = {
    fridge: EMOJIS.FRIDGE,
    freezer: EMOJIS.FREEZER,
    pantry: EMOJIS.PANTRY,
  };
  // Return mapped emoji for standard categories, or a generic tag emoji for custom categories
  return emojiMap[category.toLowerCase()] || '🏷️';
}
